import { Graph, Thing } from "schema-dts";

export type GraphWithoutContext = Omit<Graph, '@context'>;

export default function createGraph(...args: Thing[]): GraphWithoutContext {
    return {
        '@graph': args
    }
}